<template>
  <div style="width: 100%;height: 100%;" class="chart" ref="bar"></div>
</template>

<script>
import echarts from "echarts";

function setOption(args) {
  var barData = [];

  var option = {
    color: args.colorList
      ? args.colorList
      : ["#ec604d", "#fd8c28", "#7fdff0", "#32b7d3", "#C5C5C5"],
    title: {
      text: args.title,
      textStyle: {
        fontSize: 16,
        color: "#32b6d3",
        fontWeight: "normal",
        fontFamily: "Microsoft YaHei"
      },
      top: "6%",
      left: "2.5%"
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    xAxis: {
      type: "category",
      data: args.xData,
      axisLine: {
        show: true,
        lineStyle: {
          color: "#57617B", //坐标轴线线的颜色。
          width: 1,
          type: "solid"
        }
      }
    },
    legend: {
      orient: "horizontal",
      type: "scroll",
      icon: "emptyCircle",
      top: "6%",
      // left:'right',
      right: "10%",
      itemGap: 16,
      itemWidth: 10,
      itemHeight: 10,
      show: true,
      data: args.legend
    },
    grid: {
      left: "2.5%", //grid 组件离容器左侧的距离。
      right: "2.5%", //grid 组件离容器右侧的距离。
      // top:'12%',
      bottom: "2.5%", //grid 组件离容器下侧的距离。
      containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ]
    },
    // label: {
    //   show: true,
    //   position: 'top',
    //   color: '#333',
    //   fontSize: 14,
    //   fontWeight: 700
    // },
    yAxis: {
      type: "value",
      axisLine: {
        show: true,
        lineStyle: {
          color: "rgba(81,177,203,1)" //坐标轴线线的颜色
        }
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#95CCEB",
          width: 1,
          type: "solid"
        }
      },
      axisLabel: {
        // color:'red'
      }
    },
    series: [
      {
        data: args.yData[0].statistic,
        type: "bar",
        name: args.yData[0].resourceType,
        //设置柱子的宽度
        barWidth: 10,
        label: {
          show: false
        }
      },
      {
        data: args.yData[1].statistic,
        type: "bar",
        name: args.yData[1].resourceType,
        //设置柱子的宽度
        barWidth: 10,
        label: {
          show: false
        }
      },
      {
        data: args.yData[2].statistic,
        type: "bar",
        name: args.yData[2].resourceType,
        //设置柱子的宽度
        barWidth: 10,
        label: {
          show: false
        }
      },
      {
        data: args.yData[3].statistic,
        type: "bar",
        name: args.yData[3].resourceType,
        barWidth: 10,
        label: {
          show: false
        }
      },
      {
        data: args.yData[4].statistic,
        type: "bar",
        barCategoryGap: "120%",
        name: args.yData[4].resourceType,
        label: {
          show: false
        },
        //配置样式
        // itemStyle: {
        //   //通常情况下：
        //   normal: {　　　　　　　　　　　　 //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
        //     color: function(params) {
        //       var colorList = ['#F86B4F', '#FF9C00', '#FFC602', '#2DBDEF','#8B8A88'];
        //       return colorList[params.dataIndex];
        //     }
        //   },
        // },
        //设置柱子的宽度
        barWidth: 10
      }
    ]
  };

  return option;
}
export default {
  name: "WbBar",
  props: ["args"],
  watch: {
    args: function(newVal, oldVal) {
      this.args = newVal;
      this.seriesData(this.args.yData);
    }
  },
  methods: {
    initChart() {
      window.addEventListener(
        "resize",
        function() {
          this.myChart.resize();
        }.bind(this)
      );
    },
    resize: function() {
      this.myChart.resize();
    },
    reDrawChart: function(args) {
      var container = this.$el;
      this.initChart();
      this.myChart = echarts.init(container);
      this.myChart.setOption(setOption(args), false);
    }
  },
  mounted: function(el) {
    var container = this.$el;
    this.initChart();
    this.myChart = echarts.init(container);
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/wbarChart.vue